@switch (step()) {
  @case ('authData') {
    <form [formGroup]="authData" class="authData" autocomplete="off">
      <div class="authData-input">
        <mat-form-field>
          <mat-label>Email:</mat-label>
          <input
            matInput
            type="text"
            [formControl]="authData.controls.email"
            autocomplete="off"
          />
        </mat-form-field>
        @if (authData.controls.email &&
        authData.controls.email.dirty &&
        authData.controls.email.value !== user.email()) {
          <button
            class="btn confirm"
            [disabled]="!authData.controls.email.valid"
            (click)="changeEmail()"
          >
            <img src="/assets/icons/icon-check.svg" alt=""/>
          </button>
        }
        @if (authData.controls.email.value &&
        authData.controls.email.value === user.email()) {
          <button
            class="btn confirm"
            [disabled]="!authData.controls.email.valid"
            (click)="deleteEmail()"
          >
            <img src="/assets/icons/icon-trash.svg" alt=""/>
          </button>
        }
      </div>
      <div class="authData-input">
        <mat-form-field>
          <mat-label>{{ "global.phone" | translate }}:</mat-label>
          <input
            matInput
            [formControl]="authData.controls.phone"
            type="tel"
            autocomplete="off"
          />
        </mat-form-field>
        @if (authData.controls.phone &&
        authData.controls.phone.dirty &&
        authData.controls.phone.value != user.phone()) {
          <button
            class="btn confirm"
            [disabled]="!authData.controls.phone.valid"
            (click)="changePhone()"
          >
            <img src="/assets/icons/icon-check.svg" alt=""/>
          </button>
        }
        @if (authData.controls.phone.value &&
        authData.controls.phone.value === user.phone()) {
          <button
            class="btn confirm"
            [disabled]="!authData.controls.email.valid"
            (click)="deletePhone()"
          >
            <img src="/assets/icons/icon-trash.svg" alt=""/>
          </button>
        }
      </div>
      <div class="authData-input">
        <mat-form-field>
          <input
            matInput
            [formControl]="authData.controls.password"
            [type]="hide() ? 'password' : 'text'"
            [placeholder]="'******'"
            autocomplete="new-password"
          />
          <button
            matSuffix
            mat-icon-button
            (click)="clickEventPassword($event)"
            [attr.aria-pressed]="hide()"
            [attr.aria-label]="'Hide password'"
          >
            <img
              [src]="
                    hide()
                      ? 'assets/icons/icon-eye-close.svg'
                      : 'assets/icons/icon-eye-open.svg'
                  "
              alt=""
            />
          </button>
        </mat-form-field>
      </div>
      @if (authData.controls.password.value) {
        <div class="authData-input">
          <mat-form-field>
            <input
              matInput
              [formControl]="authData.controls.password_confirm"
              [type]="hide_confirm() ? 'password' : 'text'"
              [placeholder]="'auth.withPassword.repeatPassword' | translate"
              autocomplete="off"
            />
            <button
              matSuffix
              mat-icon-button
              (click)="clickEventPassword_confirm($event)"
              [attr.aria-pressed]="hide_confirm()"
              [attr.aria-label]="'Hide password'"
            >
              <img
                [src]="
                      hide_confirm()
                        ? 'assets/icons/icon-eye-close.svg'
                        : 'assets/icons/icon-eye-open.svg'
                    "
                alt=""
              />
            </button>
          </mat-form-field>
          @if (authData.controls.password.value ||
          authData.controls.password_confirm.value) {
            <button
              class="btn confirm"
              type="button"
              (click)="setPassword()"
              [disabled]="
                    !authData.controls.password.valid ||
                    !authData.controls.password.value ||
                    authData.controls.password.value !==
                      authData.controls.password_confirm.value
                  "
            >
              <img src="/assets/icons/icon-check.svg" alt=""/>
            </button>
          }
        </div>
      }
    </form>
  }
  @case ('confirm') {
    <div class="confirmation-description">
      @switch (loginType()) {
        @case (0) {
          {{ "auth.confirmation.description_mail" | translate }}
          {{ authData.controls.email.value }}
        }
        @case (1) {
          {{
            "auth.confirmation.description_phone"
              | translate: {phone: authData.controls.phone.value}
          }}
        }
      }
    </div>
    @if (codeError()) {
      <div class="errorBlock">
        {{ errorMessage()?.message }}
      </div>
    }
    <div class="otp-wrapper">
      <p-inputOtp
        [(ngModel)]="code"
        (input)="setCode()"
        class="otp"
        [length]="loginType() ? 5 : 4"
        [integerOnly]="true"
        type="number"
      >
      </p-inputOtp>
    </div>
    <button
      class="btn btn-send btn-primary"
      (click)="sendCode()"
      type="button"
      [disabled]="
            (loginType() && code.length < 5) ||
            (!loginType() && code.length < 4) ||
            !has_attempts()
          "
    >
      {{ "auth.confirmation.send" | translate }}
    </button>
    <button
      class="btn btn-resend"
      type="button"
      (click)="resendCode()"
      [disabled]="resend()"
    >
      @if (resend()) {
        {{ "auth.confirmation.resend_timer" | translate }} {{ timer() }}
        {{ "auth.confirmation.resend_sec" | translate }}
      } @else {
        {{ "auth.confirmation.resend" | translate }}
      }
    </button>
    @if (loginType() === 1) {
      <button
        class="btn btn-other"
        type="button"
        (click)="showNewTel()"
      >
        {{ "auth.confirmation.other" | translate }}
      </button>
    }
  }
  @case ('newTel') {
    <app-newtel
      [tel]="authData.controls.phone.value"
      [updatePhone]="true"
      (successPhoneUpdate)="step.set('authData');store.loadUser()"
      [newTelData]="newTelData()"
    >
    </app-newtel>
  }
}
